import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate, useNavigate } from 'react-router-dom';
import Home from './pages/Home';
import HonkaiStarRail from './pages/HonkaiStarRail';
import GensinImpact from './pages/GensinImpact';
import Tentang from './pages/Tentang';
import Navbar from './components/Navbar';
import DramaBox from './pages/dramabox/DramaBox';
import ShortBox from './pages/shortbox/ShortBox';
import DetailShortBox from './pages/shortbox/DetailShortBox';
import DetailDramaBox from './pages/dramabox/DetailDramaBox';
import KomikStation from './pages/komikstation/KomikStation';
import ScrollTop from './components/ScrollTop';
import Fab from '@mui/material/Fab';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useState, useEffect } from 'react';

// halaman admin
import Login from './pages/admin/login';
import Dashboard from './pages/admin/pages/Dashboard';
import AdminNavbar from './pages/admin/components/AdminNavbar';
import AdminHonkaiStarRail from './pages/admin/pages/HonkaiStarRail';
import AdminGensinImpact from './pages/admin/pages/GensinImpact';

function ProtectedRoute({ children }) {
  const [isValid, setIsValid] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const validateToken = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        if (isMounted) setIsValid(false);
        return;
      }

      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/validate?token=${token}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
          },
        });

        if (isMounted) {
          if (response.ok) {
            const result = await response.json();
            setIsValid(result.code === 200);
          } else {
            setIsValid(false);
          }
        }
      } catch (error) {
        console.error("Error validating token:", error);
        if (isMounted) setIsValid(false);
      }
    };

    validateToken();

    return () => {
      isMounted = false;
    };
  }, []);

  if (isValid === null) {
    return (
      <Backdrop open={true}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (!isValid) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("token");
    navigate("/login");
  }, [navigate]);

  return null;
}

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('darkMode');
    return savedMode ? JSON.parse(savedMode) : false;
  });
  const [selectedText, setSelectedText] = useState('');

  const theme = createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
    },
    typography: {
      fontFamily: '"Roboto", sans-serif',
    },
  });

  const toggleTheme = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);
    localStorage.setItem('darkMode', JSON.stringify(newMode));
  };

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <CssBaseline />
        <Content
          toggleTheme={toggleTheme}
          darkMode={darkMode}
          selectedText={selectedText}
          setSelectedText={setSelectedText}
        />
        <ScrollTop>
          <Fab size="small" aria-label="scroll back to top">
            <KeyboardArrowUpIcon />
          </Fab>
        </ScrollTop>
      </Router>
    </ThemeProvider>
  );
}

function Content({ toggleTheme, darkMode, selectedText, setSelectedText }) {
  const location = useLocation();

  const hideNavbarRoutes = ['/login'];
  const adminRoutes = ['/admin', '/admin/*'];

  const showNavbar = !hideNavbarRoutes.includes(location.pathname);
  const showAdminNavbar = adminRoutes.some((route) => location.pathname.startsWith(route));

  return (
    <>
      {showNavbar && !showAdminNavbar && (
        <Navbar toggleTheme={toggleTheme} darkMode={darkMode} setSelectedText={setSelectedText} />
      )}
      {showAdminNavbar && <AdminNavbar toggleTheme={toggleTheme} darkMode={darkMode} setSelectedText={setSelectedText} />}
      <Container fixed>
        <div id="back-to-top-anchor" />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<ProtectedRoute><Dashboard selectedText={selectedText} /></ProtectedRoute>} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/admin/dashboard" element={<ProtectedRoute><Dashboard selectedText={selectedText} /></ProtectedRoute>} />
          <Route path="/admin/honkai-star-rail" element={<ProtectedRoute><AdminHonkaiStarRail selectedText={selectedText} /></ProtectedRoute>} />
          <Route path="/admin/genshin-impact" element={<ProtectedRoute><AdminGensinImpact selectedText={selectedText} /></ProtectedRoute>} />
          <Route path="/honkai-star-rail" element={<HonkaiStarRail selectedText={selectedText} />} />
          <Route path="/genshin-impact" element={<GensinImpact selectedText={selectedText} />} />
          <Route path="/tentang" element={<Tentang selectedText={selectedText} />} />

          {/* Nonton Drama Pendek */}
          <Route path="/shortbox" element={<ShortBox selectedText={selectedText} />} />
          <Route path="/shortbox/:bookId/:bookName" element={<DetailShortBox />} />
          <Route path="/dramabox" element={<DramaBox selectedText={selectedText} />} />
          <Route path="/dramabox/:bookId/:bookNameLower" element={<DetailDramaBox />} />

          {/* Baca Komik */}
          <Route path="/komik" element={<KomikStation selectedText={selectedText} />} />
          </Routes>
      </Container>
    </>
  );
}

export default App;
